// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"196":"28c0461e","1115":"28c0461e","2882":"ce68d73e","3920":"28c0461e","5031":"28c0461e","6159":"28c0461e","6469":"ce68d73e","8186":"28c0461e","9119":"28c0461e","9490":"28c0461e"}[chunkId] + ".chunk.css";
};